import React, { useState } from 'react'
import MEModal from '../../components/MEModal'
import { Form } from 'react-bootstrap'
import { Button } from '@CommonComponents/buttons'
import { toast } from '@CommonComponents/toast'
import { useStateValue } from '@State'
import { removeSection } from '../actions'

export const removeSectionItem = {
  id: 'remove-section',
  label: 'Remove Section',
  icon: 'fa-light fa-minus-circle',
  danger: true,
}

export const RemoveSectionModal = ({ section, sectionName, show, close }) => {
  const [currentState, dispatch] = useStateValue()
  const [removeSectionId, setRemoveSectionId] = useState('')
  const [sectionSelected, setSectionSelected] = useState(false)

  const handleRemoveSectionName = (e) => {
    let selected = !isNaN(e.target.value)
    setRemoveSectionId(e.target.value)
    setSectionSelected(selected)
  }

  const submitRemoveSection = async () => {
    let data = { ...currentState.filters }
    data.section_id = section
    data.section_destination_id = removeSectionId
    data.pageNum = currentState.currentCourseMemPage
    data.archivedPageNum = currentState.currentArchivePage
    close()
    try {
      let response = await removeSection(data, dispatch)
      if (response.status === 200) {
        toast.success('Successfully removed the section.')
      } else {
        toast.error(response.data.error)
      }
    } catch (err) {
      toast.error('There was a problem removing the section.')
    }
  }

  return (
    <MEModal show={show} close={close} title="Remove Section">
      <form onSubmit={e => e.preventDefault()}>
        <p>
          This will permanently remove section {sectionName}.
        </p>
        <Form.Group>
          <Form.Label>Move those in this section to:</Form.Label>
          <Form.Control
            as="select"
            placeholder="select"
            onChange={handleRemoveSectionName}
          >
            <option>- Select Section -</option>
            {currentState.allSectionData
              .filter(r => r.secName !== sectionName)
              .map((r, key) => (
                <option key={key} value={r.id}>
                  {r.secName}
                </option>
              ))}
          </Form.Control>
        </Form.Group>
        {sectionSelected ? (
          <div className="text-center">
            <Button
              type="button"
              className="me-btn me-btn-danger"
              onClick={submitRemoveSection}
            >
              Remove section
            </Button>
          </div>
        ) : null}
      </form>
    </MEModal>
  )
}
